import { useTranslation } from 'react-i18next';

import { SPECIAL_AGENT_IDS } from '@/entities/agent';
import { ROUTES } from '@/shared/config/routes';
import { getAdminToolsListDisplayName } from '@/features/admin/lib/canonicalAdminToolLabels';

import { AdminPageShell } from '../AdminPageShell';
import { AgentBasicInformationSection } from './AgentBasicInformationSection';

export function AudienceAgentConfigPage() {
  const { t } = useTranslation('admin');
  const agentId = SPECIAL_AGENT_IDS.AUDIENCE_FLOW;
  const title = getAdminToolsListDisplayName(agentId, '');

  // `ownsBodyInset`: the padded scroll region below is this page's own inset, and it is
  // exactly the one the shell would otherwise add.
  return (
    <AdminPageShell
      title={title}
      parents={[{ label: t('admin.adminLayout.tools'), href: ROUTES.ADMIN_TOOLS }]}
      ownsBodyInset
    >
      <div className="flex-1 px-6 py-6 overflow-y-auto">
        <AgentBasicInformationSection agentId={agentId} />
      </div>
    </AdminPageShell>
  );
}
